<template>
  <div class="plansPay" :class="style" @click="$emit('click')">
    <div class="selectPolicy">
        <div class="selectPolicy__header">
          <div class="accordionQuoteMem__title">{{ policyTitle }}</div>
          <div class="accordionQuoteMem__count">{{ policyName }}</div>
          <div class="accordionQuoteMem__count">{{ policyNumber }}</div>
        </div>
        <div
          v-if="policyEndDate"
          class="selectPolicy__until"
          :class="{'selectPolicy__until_fast': untilError }">
            {{ $t('renew_selectpolicy_until') }} {{ formattedEndDate }}
        </div>
    </div>
  </div>
</template>

<script>
import prodCodeMap from '@/assets/maps/prodCodeMap.json'
import format from 'date-fns/format'
import { enGB as en, arSA as ar } from 'date-fns/locale'
export default {
  name: 'SelectPolicyCard',
  props: {
    policy: { type: Object },
    cursor: { type: Boolean, default: false }
  },
  data () {
    return {}
  },
  computed: {
    formatLocale () {
      if (this.locale === 'ar') {
        return ar
      } else {
        return en
      }
    },
    locale () {
      return this.$i18n.locale
    },
    product () {
      if (!this.policy) return null
      return prodCodeMap.find((product) =>
        product.code === this.policy?.prodCode &&
        (product.vehicleUsage ? product.vehicleUsage === this.policy.vehicleUsage : true)) || null
    },
    policyNumber () {
      return `${this.$t('renew_policy_number')}: ${this.policy.policyNo}`
    },
    policyName () {
      if (!this.product) return ''
      return this.$te(this.product?.nameT) ? this.$t(this.product.nameT) : this.product.name
    },
    policyTitle () {
      if (!this.policy) return ''
      return this.policy.makeModel.trim() !== '-' ? this.policy?.makeModel : this.policy?.policyNo
    },
    policyStyle () {
      return this.product ? `${this.product.type}-policy` : 'car-policy'
    },
    policyEndDate () {
      if (!(this.policy && this.policy?.polEndDate)) return null
      return new Date(this.policy.polEndDate)
    },
    formattedEndDate () {
      if (!this.policyEndDate) return ''
      const marker = this.locale === 'ar' ? '\u200f' : ''
      const formatString = this.locale === 'ar' ? 'd MMMM yyyy' : 'd MMM yyyy'
      return this.policyEndDate ? format(this.policyEndDate, `${marker}${formatString}`, { locale: this.formatLocale }) : ''
    },
    untilError () {
      if (!this.policyEndDate?.getDate) return false
      const now = new Date()
      const untilDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30)
      return untilDate - this.policyEndDate > 0
    },
    style () {
      const classes = [this.policyStyle]
      if (this.cursor) classes.push('cursor')
      return classes
    }
  }
}
</script>

<style lang="sass" scoped>
.cursor
  cursor: pointer
.car-policy
  overflow: hidden
  position: relative
  &::before
    width: 3px
    height: 100%
    position: absolute
    background: rgba(130, 255, 90, 0.66)
    content: ""
    display: block
.moto-policy
  overflow: hidden
  position: relative
  &::before
    width: 3px
    height: 100%
    position: absolute
    background: #7CF7AF
    content: ""
    display: block
.boat-policy
  overflow: hidden
  position: relative
  &::before
    width: 3px
    height: 100%
    position: absolute
    background: #77F0E9
    content: ""
    display: block
.pab-policy
  overflow: hidden
  position: relative
  &::before
    width: 3px
    height: 100%
    position: absolute
    background: #CFBCE8
    content: ""
    display: block
.home-policy
  overflow: hidden
  position: relative
  &::before
    width: 3px
    height: 100%
    position: absolute
    background: #D7EAFF
    content: ""
    display: block
.travel-policy
  overflow: hidden
  position: relative
  &::before
    width: 3px
    height: 100%
    position: absolute
    background: #FFE814
    content: ""
    display: block
</style>
